import { render, staticRenderFns } from "./InvoiceAdd.vue?vue&type=template&id=2fd2fb1b&scoped=true&"
import script from "./InvoiceAdd.vue?vue&type=script&lang=js&"
export * from "./InvoiceAdd.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InvoiceAdd.vue?vue&type=style&index=1&id=2fd2fb1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2fb1b",
  null
  
)

export default component.exports